import React from "react";
import { ExistingEntityPreviewProps } from "../ExistingEntityPreview";
import CommunicationSetEditor from "../../../communications/CommunicationSetEditor";

const ExistingCommSetPreview = (props: ExistingEntityPreviewProps) => {
  return (
    <CommunicationSetEditor
    resourceID={-1}
    resourceName={props.communicationSet?.name || ""}
    communicationSetID={props.communicationSet?.id || -1}
    intervalID={0}
    currentParent={1}
    inDrawer={true}
    intervalSetEditMode={false}
    previewMode={props.preview}
  />
  );
};

export default ExistingCommSetPreview;
